import React from 'react'
import { Footer, Navbar, Product } from "../Components"


const Products = () => {
  return (
    <>
      <Navbar />
      <Product />
      <Footer />
    </>
  )
}

export default Products